// Entry.jsx

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { filterXSS } from 'xss';

import { initRouter } from '@utils/history';
import { getPostLoginRedirectPath } from '@utils/postLoginRedirect';
import AppContainer from './appContainer';

/** When the SPA is hosted under a subpath (e.g. /gateway on Azure), must match server URL or no <Route> matches. */
function getRouterBasename() {
  const raw = process.env.REACT_APP_ROUTER_BASENAME;
  if (raw == null || raw === '' || raw === '/') {
    return '/';
  }
  const withSlash = raw.startsWith('/') ? raw : `/${raw}`;
  return withSlash.endsWith('/') ? withSlash.slice(0, -1) : withSlash;
}
import login_new from '@modules/login_new/login_new';
import Reg from '@modules/register';
import Error from '@components/error';
import { AccessControlForTSADBM } from '@modules/systemSetting';
import AppkitThemeContainer from '@components/appkitThemeContainer/AppkitThemeContainer';

// HOC to redirect logged-in users away from auth pages
const RedirectIfLoggedIn = (Component) => {
  return connect((state) => ({ isLogin: state.login.isLogin }))(
    ({ isLogin, ...props }) => {
      if (isLogin) {
        return <Redirect to={getPostLoginRedirectPath()} />;
      }
      return <Component {...props} />;
    },
  );
};

// Wrap login component
const LoginWithRedirect = RedirectIfLoggedIn(login_new);

class Entry extends Component {
  constructor(props) {
    super(props);
    const { match, location, history } = props;

    initRouter({
      match,
      location,
      history,
    });
  }

  render() {
    // Handle registration email redirect - check for both token types
    const currentUrl = window.location.href;
    const isFromRegistrationEmail =
      currentUrl?.indexOf('/?registrationToken') !== -1 ||
      currentUrl?.indexOf('/?activationToken') !== -1;

    if (isFromRegistrationEmail) {
      // Get the query string starting from the first '?'
      const queryStringIndex = currentUrl.indexOf('?');
      if (queryStringIndex !== -1) {
        const urlParams = currentUrl.substr(queryStringIndex);
        window.location.replace(filterXSS(`/registration${urlParams}`));
        return null;
      }
    }

    return (
      <div className="app">
        <Router basename={getRouterBasename()}>
          <AppkitThemeContainer>
            <Switch>
              {/* Public Routes - Order matters! More specific routes first */}
              <Route path="/error" component={Error} />
              <Route path="/registration" component={Reg} />

              {/* Auth Routes - Redirect to app if logged in */}
              <Route path="/login" component={LoginWithRedirect} />

              {/* Access Controls */}
              {/* <Route
                path="/accesscontrols"
                exact
                component={AccessControlForTSADBM}
              /> */}

              {/* Protected Routes - This should be LAST since "/" matches everything */}
              <Route path="/" component={AppContainer} />
            </Switch>
          </AppkitThemeContainer>
        </Router>
      </div>
    );
  }
}

Entry.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
};

export default Entry;
